<template>
  <div class="standard-card" :class="customClass">
    <div v-if="title" class="standard-card__title">
      <h4>{{ title }}</h4>
    </div>
    <slot />
    <div v-if="$slots.footer" class="standard-card__footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, default: '' },
  customClass: { type: [String, Array, Object], default: '' },
})
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.standard-card {
  background-color: white;
  border-radius: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  height: fit-content;

  &__title {
    h4 {
      font-family: OpenSansBold;
      color: $bluFour;
      margin-top: 0;
      margin-bottom: 10px;
    }
  }

  &__footer {
    margin-top: 10px;
    padding-top: 8px;
    border-top: 1px solid $grayFive;
  }
}
</style>
